export default class Endereco {
  constructor(id = '',
    logradouro = '',
    numero = '',
    complemento = '',
    bairro = '',
    municipio = '',
    cep = '',
    uf = '',
    pais = '',
  ) {
    this.id = id;
    this.logradouro = logradouro;
    this.numero = numero;
    this.complemento = complemento;
    this.bairro = bairro;
    this.municipio = municipio;
    this.cep = cep;
    this.uf = uf;
    this.pais = pais;
  }
}
